import {
  getComponentCssUrl,
  getGlobalCssUrl,
} from '@/components/webcomponents/Global/loadDependency'

// Lazy template creation to avoid calling getCdnUrl at module load time
function createControlInfoTemplate() {
  const t = document.createElement('template')
  t.innerHTML = `
<link href="${getGlobalCssUrl('trustage-aa--wc.css')}" rel="stylesheet" />
<link href="${getComponentCssUrl('ControlInfo--wc.css')}" rel="stylesheet" />
`

  return t
}

const getTemplateControlInfoStyles = () => createControlInfoTemplate()
export { getTemplateControlInfoStyles }
